// src/store/settingsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSettings } from "../API/settings";

// Thunk for fetching settings
export const fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async (catererId, { rejectWithValue }) => {
    try {
      const response = await getSettings(catererId);
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    data: null,
    lastFetched: null,
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default settingsSlice.reducer;
